import { useContext, useMemo } from "react";
import { RecordContext } from "../../record/Record";
import { useRecords } from "../../../api/useRecords";
import { TimeOffType } from "../../../utils/timeOffUtils";
import { isSameDay, parseISO, eachDayOfInterval } from "date-fns";

export type TimeOffItem = {
    id: number;
    start_date: string;
    end_date: string;
    type: TimeOffType;
};

const EXCLUDED_TIME_OFF_TYPES = ["day_off"];

export const useTherapistTimeOff = (year: number) => {
    const recordContext = useContext(RecordContext);

    const therapistUserIds = useMemo(() => {
        const therapists = recordContext?.item?.theurapists_involved_in_treamtent ?? [];
        const userIds = therapists
            .map((t: any) => t?.technicians_id?.user_id?.id)
            .filter(Boolean) as Array<string>;
        return userIds;
    }, [recordContext?.item?.theurapists_involved_in_treamtent]);

    const { data: timeOffData } = useRecords("time_off", "*.*", {
        extraOptions: {
            filter: {
                user: { id: { _in: therapistUserIds } },
                start_date: { _gte: `${year}-01-01` },
                end_date: { _lte: `${year}-12-31` },
                type: { _nin: EXCLUDED_TIME_OFF_TYPES },
            },
            pageSize: -1,
        },
        enabled: therapistUserIds.length > 0,
    });

    const timeOffItems = (timeOffData?.items ?? []) as Array<TimeOffItem>;

    return { timeOffItems };
};

export const getTimeOffsForDay = (timeOffItems: Array<TimeOffItem>, day: Date) => {
    const matchingTimeOffs = timeOffItems.filter((timeOff) => {
        const startDate = parseISO(timeOff.start_date);
        const endDate = parseISO(timeOff.end_date);
        const daysInRange = eachDayOfInterval({ start: startDate, end: endDate });
        const isDayInRange = daysInRange.some((d) => isSameDay(d, day));
        return isDayInRange;
    });
    return matchingTimeOffs;
};

